import { render, staticRenderFns } from "./GroupLegendIndexOfHealth.vue?vue&type=template&id=8ab8b72a&scoped=true"
import script from "./GroupLegendIndexOfHealth.vue?vue&type=script&lang=js"
export * from "./GroupLegendIndexOfHealth.vue?vue&type=script&lang=js"
import style0 from "./GroupLegendIndexOfHealth.vue?vue&type=style&index=0&id=8ab8b72a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab8b72a",
  null
  
)

export default component.exports